<bp-hl-area-container name="Naturraum">
	<div class="touch-form">
		<!-- Geologie / Klimastufe -->
		<div class="form-row">
			<div class="form-label-cell">Geologie</div>
			<div class="form-input-cell multi">
				<wd-typeahead name="GeologieOben" label="oben" [(model)]="data.extendedHeader.geologie.oben"></wd-typeahead>
				<wd-list-input name="GeologieTrenner" options="|/|//" [(model)]="data.extendedHeader.geologie.trenner"></wd-list-input>
				<wd-typeahead *ngIf="data.extendedHeader.geologie.trenner" name="GeologieUnten" label="unten" [(model)]="data.extendedHeader.geologie.unten"></wd-typeahead>
			</div>
			<div class="form-label-cell">Klimastufe</div>
			<div class="form-input-cell">
				<wd-an-typeahead name="Klimastufe" [(model)]="data.extendedHeader.klimaStufe" [acceptOtherValues]="true"></wd-an-typeahead>
			</div>
		</div>

		<!-- Wuchsgebiet -->
		<div class="form-row">
			<div class="form-label-cell">Wuchsgebiet</div>
			<div class="form-input-cell">
				<wd-typeahead name="Wuchsgebiet" [(model)]="data.extendedHeader.wuchsgebiet"></wd-typeahead>
			</div>
			<div class="form-label-cell">Wuchsbezirk</div>
			<div class="form-input-cell">
				<wd-typeahead name="Wuchsbezirk" [(model)]="data.extendedHeader.wuchsbezirk" [filter]="wuchsbezirkFilter(data.extendedHeader.wuchsgebiet)"></wd-typeahead>
			</div>
		</div>

		<!-- Relief (nur B) - Erweitert nach SEA -->
		@if (isB() && data.extendedHeader.relief) {
			<div class="form-section-header">Relief</div>

			<!-- Neigung -->
			<div class="form-row">
				<div class="form-label-cell">Neigung <wd-help name="Neigungsstufe"></wd-help></div>
				<div class="form-input-cell">
					<wd-list-input name="Neigungsstufe" [(model)]="data.extendedHeader.relief.neigungsstufe"
						(modelChange)="onNeigungsstufeChange($event)"></wd-list-input>
				</div>
				<div class="form-label-cell">Grad</div>
				<div class="form-input-cell">
					<wd-number-input name="NeigungGrad" [(model)]="data.extendedHeader.relief.neigungGrad"
						[min]="0" [max]="90" placeholder=""
						(modelChange)="onNeigungGradChange($event)"></wd-number-input>
				</div>
			</div>

			<!-- Wölbung und Hangrichtung -->
			<div class="form-row">
				<div class="form-label-cell">Wölbung <wd-help name="Woelbung"></wd-help></div>
				<div class="form-input-cell">
					<wd-list-input name="Woelbung" [(model)]="data.extendedHeader.relief.woelbung"></wd-list-input>
				</div>
				<div class="form-label-cell">Hangrichtung <wd-help name="Hangrichtung"></wd-help></div>
				<div class="form-input-cell">
					@if (istHangmitRichtung()) {
						<wd-list-input name="Hangrichtung" [(model)]="data.extendedHeader.relief.hangrichtung"></wd-list-input>
					} @else {
						<span class="text-muted">—</span>
					}
				</div>
			</div>

			<!-- Einbindung - kontextabhängig -->
			<div class="form-row">
				@if (istEbeneOderRampe()) {
					<!-- Ebene/Rampe: Einbindung in Nachbarschaft -->
					<div class="form-label-cell">Einbindung <wd-help name="ReliefformUmgebung"></wd-help></div>
					<div class="form-input-cell">
						<wd-list-input name="ReliefformUmgebung" [(model)]="data.extendedHeader.relief.einbindungEbene"></wd-list-input>
					</div>
					<div class="form-label-cell"></div>
					<div class="form-input-cell"></div>
				} @else {
					<!-- Hang: Hanganschluss und Hangteil -->
					<div class="form-label-cell">Hanganschluss <wd-help name="Hanganschluss"></wd-help></div>
					<div class="form-input-cell">
						<wd-list-input name="Hanganschluss" [(model)]="data.extendedHeader.relief.hanganschluss"></wd-list-input>
					</div>
					<div class="form-label-cell">Hangteil <wd-help name="Hangteil"></wd-help></div>
					<div class="form-input-cell">
						<wd-list-input name="Hangteil" [(model)]="data.extendedHeader.relief.hangteil"></wd-list-input>
					</div>
				}
			</div>

			<!-- Höhenspanne (nur bei Hängen) -->
			@if (!istEbeneOderRampe()) {
				<div class="form-row">
					<div class="form-label-cell">Höhenspanne <wd-help name="Hoehenspanne"></wd-help></div>
					<div class="form-input-cell">
						<wd-number-input name="Hoehenspanne" [(model)]="data.extendedHeader.relief.hoehenspanne"
							[min]="0" ></wd-number-input>
					</div>
					<div class="form-label-cell"></div>
					<div class="form-input-cell"></div>
				</div>
			}

			<!-- Innere Rauhheit -->
			<div class="form-row">
				<div class="form-label-cell">Innere Rauhheit <wd-help name="InnereRauhheit"></wd-help></div>
				<div class="form-input-cell full-width">
					<wd-list-input name="InnereRauhheit" [(model)]="data.extendedHeader.relief.innereRauhheit"></wd-list-input>
				</div>
			</div>

			<!-- Legacy-Felder (optional anzeigen) -->
			@if (data.extendedHeader.relief.relief || data.extendedHeader.relief.reliefUmgebung) {
				<div class="form-row text-muted">
					<div class="form-label-cell">Relief (alt)</div>
					<div class="form-input-cell">
						<wd-typeahead name="Reliefform" [(model)]="data.extendedHeader.relief.relief"></wd-typeahead>
					</div>
					<div class="form-label-cell">Umgebung (alt)</div>
					<div class="form-input-cell">
						<wd-typeahead name="ReliefformUmgebung" [(model)]="data.extendedHeader.relief.reliefUmgebung"></wd-typeahead>
					</div>
				</div>
			}
		}

		<!-- Mesoklima (nur nicht-M) -->
		<div class="form-row" *ngIf="!isM()">
			<div class="form-label-cell">Mesoklima</div>
			<div class="form-input-cell">
				<wd-list-input name="Mesoklima" [(model)]="data.extendedHeader.mesoklima" options="|fr|tr"></wd-list-input>
			</div>
			<div class="form-label-cell"></div>
			<div class="form-input-cell"></div>
		</div>

		<!-- Morphologie (nur nicht-M) -->
		@if (!isM()) {
			<div class="form-section-header">Morphologie</div>
			<div class="form-row">
				<div class="form-label-cell">Morphologie 1</div>
				<div class="form-input-cell">
					<wd-typeahead name="Morphologie0" [(model)]="data.extendedHeader.morphologie[0]"></wd-typeahead>
				</div>
				<div class="form-label-cell">Morphologie 2</div>
				<div class="form-input-cell">
					<wd-typeahead name="Morphologie1" [(model)]="data.extendedHeader.morphologie[1]"></wd-typeahead>
				</div>
			</div>
			<div class="form-row" *ngIf="data.extendedHeader.morphologie.length > 2">
				<div class="form-label-cell">Morphologie 3</div>
				<div class="form-input-cell">
					<wd-typeahead name="Morphologie2" [(model)]="data.extendedHeader.morphologie[2]"></wd-typeahead>
				</div>
				<div class="form-label-cell" *ngIf="data.extendedHeader.morphologie.length > 3">Morphologie 4</div>
				<div class="form-input-cell" *ngIf="data.extendedHeader.morphologie.length > 3">
					<wd-typeahead name="Morphologie3" [(model)]="data.extendedHeader.morphologie[3]"></wd-typeahead>
				</div>
				<ng-container *ngIf="data.extendedHeader.morphologie.length <= 3">
					<div class="form-label-cell"></div>
					<div class="form-input-cell"></div>
				</ng-container>
			</div>
			<div class="form-row">
				<div class="form-label-cell">KMgCaP-Serie</div>
				<div class="form-input-cell">
					<wd-list-input [(model)]="data.extendedHeader.kMgCaPSerie" name="KMgCaP-Serie"></wd-list-input>
				</div>
				<div class="form-label-cell"></div>
				<div class="form-input-cell"></div>
			</div>
		}

		<!-- Witterung -->
		<div class="form-section-header">Witterung <wd-help name="Witterung" [context]="{bohrpunkt: data}"></wd-help></div>
		<div class="form-row">
			<div class="form-label-cell weather-buttons">
				<button type="button" class="btn btn-sm btn-outline-secondary" (click)="fetchWeather(false)" [disabled]="weatherLoading" title="Wetter für Aufnahmedatum abrufen">
					<span *ngIf="weatherLoading" class="spinner-border spinner-border-sm me-1"></span>
					Datum
				</button>
				<button type="button" class="btn btn-sm btn-outline-secondary" (click)="fetchWeather(true)" [disabled]="weatherLoading" title="Aktuelles Wetter abrufen">
					Jetzt
				</button>
			</div>
			<div class="form-input-cell full-width">
				<wd-text-input name="Witterung" [(model)]="data.extendedHeader.witterung"></wd-text-input>
			</div>
		</div>

		<!-- Moortypen (nur M) -->
		<ng-container *ngIf="isM()">
			<div class="form-section-header">Moortypen</div>
			<div class="form-row">
				<div class="form-label-cell">Ökolog. Typ</div>
				<div class="form-input-cell">
					<wd-typeahead name="Ökologischer Moortyp" [(model)]="data.extendedHeader.moorTyp!.oekologisch"></wd-typeahead>
				</div>
				<div class="form-label-cell">Hydrogen. Typ</div>
				<div class="form-input-cell">
					<wd-typeahead name="Hydrogenetischer Moortyp" [(model)]="data.extendedHeader.moorTyp!.hydrogenetisch"></wd-typeahead>
				</div>
			</div>
			<div class="form-row" *ngIf="data.extendedHeader.relief">
				<div class="form-label-cell">Relief Best.</div>
				<div class="form-input-cell">
					<wd-list-input name="Reliefform Bestand" [(model)]="data.extendedHeader.relief.reliefBestand"></wd-list-input>
				</div>
				<div class="form-label-cell">Relief Veg.</div>
				<div class="form-input-cell">
					<wd-list-input name="Reliefform Bodenvegetation" [(model)]="data.extendedHeader.relief.reliefBodenvegetation"></wd-list-input>
				</div>
			</div>
		</ng-container>
	</div>
</bp-hl-area-container>
